/* Glawhaus — storefront interactions
   Vanilla JS, no dependencies. Progressive: every feature degrades to a normal
   page load / form POST if JS is unavailable. */
(function () {
  "use strict";

  var money = function (cents) {
    var f = (window.Glawhaus && window.Glawhaus.moneyFormat) || "${{amount}}";
    var v = (cents / 100).toFixed(2);
    var parts = v.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return f.replace(/\{\{\s*amount\s*\}\}/, parts.join("."));
  };

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- header */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 8); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* --------------------------------------------------------------- drawers */
  var overlay = $("[data-overlay]");
  var openDrawer = null;
  var lastFocus = null;

  function trapFocus(e) {
    if (!openDrawer || e.key !== "Tab") return;
    var f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', openDrawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function drawerOpen(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    openDrawer = el;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var target = el.querySelector("[data-drawer-focus]") || el.querySelector("button, a");
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function drawerClose() {
    if (!openDrawer) return;
    openDrawer.classList.remove("is-open");
    openDrawer.setAttribute("aria-hidden", "true");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
    openDrawer = null;
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      drawerOpen($("#" + opener.getAttribute("data-drawer-open")));
      return;
    }
    if (e.target.closest("[data-drawer-close]")) { e.preventDefault(); drawerClose(); }
  });
  if (overlay) overlay.addEventListener("click", drawerClose);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") drawerClose();
    trapFocus(e);
  });

  /* ------------------------------------------------------------------ cart */
  function refreshCartUI(cart) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var drawerBody = $("[data-cart-body]");
    if (drawerBody) {
      fetch(window.Glawhaus.routes.cart + "?section_id=cart-drawer-content", { credentials: "same-origin" })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer-inner]");
          var target = $("[data-cart-drawer-inner]");
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () { window.location = window.Glawhaus.routes.cart; });
    }
  }

  function cartAdd(id, qty, btn) {
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.innerHTML = "Adding…"; }
    return fetch(window.Glawhaus.routes.cartAdd, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || "Could not add to cart");
        return fetch(window.Glawhaus.routes.cart + ".js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        drawerOpen($("#cart-drawer"));
        if (btn) { btn.removeAttribute("aria-disabled"); btn.innerHTML = original; }
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute("aria-disabled"); btn.innerHTML = original; }
        var note = btn && btn.closest("form") ? btn.closest("form").querySelector("[data-form-error]") : null;
        if (note) { note.textContent = err.message; note.hidden = false; }
        else window.alert(err.message);
      });
  }

  function cartChange(line, quantity) {
    return fetch(window.Glawhaus.routes.cartChange, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartUI(cart);
        if (document.body.classList.contains("template-cart")) window.location.reload();
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[type="submit"]');
    if (!idField || !idField.value) return;
    cartAdd(idField.value, qtyField ? parseInt(qtyField.value, 10) || 1 : 1, btn);
  });

  document.addEventListener("click", function (e) {
    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      cartAdd(quick.getAttribute("data-quick-add"), 1, quick);
      return;
    }
    var rm = e.target.closest("[data-cart-remove]");
    if (rm) { e.preventDefault(); cartChange(parseInt(rm.getAttribute("data-cart-remove"), 10), 0); return; }
    var step = e.target.closest("[data-qty-step]");
    if (step) {
      e.preventDefault();
      var wrap = step.closest(".qty");
      var input = wrap.querySelector("input");
      var next = Math.max(parseInt(input.getAttribute("min") || "1", 10),
        (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute("data-qty-step"), 10));
      input.value = next;
      var lineAttr = wrap.getAttribute("data-cart-line");
      if (lineAttr) cartChange(parseInt(lineAttr, 10), next);
      else input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-line] input");
    if (!input) return;
    var line = parseInt(input.closest("[data-cart-line]").getAttribute("data-cart-line"), 10);
    cartChange(line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* --------------------------------------------------------------- gallery */
  $$("[data-gallery]").forEach(function (g) {
    var slides = $$("[data-gallery-slide]", g);
    var thumbs = $$("[data-gallery-thumb]", g);
    function show(i) {
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle("is-active", k === i);
        t.setAttribute("aria-selected", k === i ? "true" : "false");
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i); }); });
  });

  /* ------------------------------------------------------- variant picking */
  $$("[data-variant-root]").forEach(function (root) {
    var data = JSON.parse(root.querySelector("[data-variant-json]").textContent);
    var form = root.querySelector("[data-product-form]");
    if (!form) return;
    var idField = form.querySelector('[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var priceEl = root.querySelector("[data-variant-price]");
    var compareEl = root.querySelector("[data-variant-compare]");

    root.addEventListener("change", function (e) {
      if (!e.target.closest("[data-option]")) return;
      var chosen = $$("[data-option] input:checked", root).map(function (i) { return i.value; });
      var match = data.find(function (v) {
        return v.options.every(function (o, k) { return o === chosen[k]; });
      });
      if (!match) return;
      idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else compareEl.hidden = true;
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute("data-add-text") : "Sold out";
      }
      if (history.replaceState) {
        history.replaceState({}, "", window.location.pathname + "?variant=" + match.id);
      }
    });
  });

  /* ------------------------------------------------------------- accordion */
  /* Sincroniza la clase is-open en el .acc__item. El CSS abre con :has(), pero
     esta clase es el respaldo para navegadores sin soporte. */
  function accSync(btn) {
    var item = btn.closest(".acc__item");
    if (item) item.classList.toggle("is-open", btn.getAttribute("aria-expanded") === "true");
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-acc-btn]");
    if (!btn) return;
    var open = btn.getAttribute("aria-expanded") === "true";
    var group = btn.closest("[data-acc-single]");
    if (group && !open) {
      $$("[data-acc-btn]", group).forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        accSync(b);
      });
    }
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    accSync(btn);
  });

  // Estado inicial: la primera pregunta viene abierta desde el Liquid.
  $$("[data-acc-btn]").forEach(accSync);

  /* ----------------------------------------------------------- sticky buy */
  var sticky = $("[data-sticky-buy]");
  var anchor = $("[data-buy-anchor]");
  if (sticky && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle("is-visible", !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { rootMargin: "0px 0px -100% 0px" }).observe(anchor);
  }

  /* -------------------------------------------------------------- reveals */
  var revealables = $$(".reveal");
  if (revealables.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* --------------------------------------------------------- sort / filter */
  $$("[data-auto-submit]").forEach(function (sel) {
    sel.addEventListener("change", function () { sel.form.submit(); });
  });

  /* ------------------------------------------------------------- marquee */
  $$("[data-marquee]").forEach(function (m) {
    var track = m.firstElementChild;
    if (track && track.children.length) track.innerHTML += track.innerHTML;
  });
})();
